import React, { memo, useMemo } from "react";
import { couponService } from "../../api/services/coupon.service";
import { useInfiniteQuery } from "@tanstack/react-query";
import CouponTicketItem from "../coupon/CouponTicketItem";
import CouponSelectSheet from "../coupon/CouponSelectSheet";

//react-query v4->v5 마이그레이션으로 인해 getNextPageParam 함수의 반환값이 string에서 number로 변경됨

// v5 문법으로 변경
// useInfiniteQuery({
//   queryKey: ["userCouponSelectionList"],
//   initialPageParam: 1,                          // ← 추가
//   queryFn: async ({ pageParam }) => {           // ← 기본값 제거
//     const response = await couponService.getCouponsByPage(pageParam as number);
//     return response.data;
//   },
//   getNextPageParam: (lastPage) => { ... },
// });

const CouponTicketSelectModal = (props) => {
  const { data, isSuccess, isLoading, fetchNextPage, hasNextPage } = useInfiniteQuery({
    queryKey: ["userCouponSelectionList"],
    initialPageParam: 1,
    queryFn: async ({ pageParam }) => {
      const response = await couponService.getCouponsByPage(pageParam as number);
      return response.data;
    },
    getNextPageParam: (lastPage) => {
      if (lastPage && lastPage.next) {
        const match = lastPage.next.match(/page=(\d+)/);
        if (match) {
          return match[1];
        }
      }
      return undefined;
    },
  });

  const filteredCoupons = useMemo(() => {
    if (!data || !isSuccess) return [];

    return data.pages.flatMap((page, i) =>
      page.results
        .filter((coupons) => coupons.coupon.bound_type === "ticket" && coupons.state === "사용안함")
        .map((coupon, j) => (
          <CouponTicketItem
            key={`${i}-${j}`}
            coupon={coupon}
            ticket={props.ticket}
            selectCoupon={props.selectCoupon}
            toggleTicketDiscountCouponSelection={props.toggleTicketDiscountCouponSelection}
          />
        ))
    );
  }, [data, isSuccess, props.ticket, props.selectCoupon, props.toggleTicketDiscountCouponSelection]);

  const isCouponSelected = props.selectCoupon?.some(
    (c: { product_id: unknown }) => String(c.product_id) === String(props.ticket?.id)
  );

  return (
    <CouponSelectSheet
      isOpen={props.visible}
      onClose={() => props.setVisible(false)}
      onApply={() => props.setVisible(false)}
      applyDisabled={!isCouponSelected}
      loading={isLoading}
      isEmpty={isSuccess && filteredCoupons.length === 0}
      hasMore={hasNextPage}
      onLoadMore={() => fetchNextPage()}
    >
      {filteredCoupons}
    </CouponSelectSheet>
  );
};
export default memo(CouponTicketSelectModal);
